// extracted by mini-css-extract-plugin
export default {"slot":"mobile-preview-toggle_slot__7w-qK","toggle":"mobile-preview-toggle_toggle__XbJMg"};